"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyTradeHistoryDetailRequest = void 0;
var MyTradeHistoryDetailRequest = /** @class */ (function () {
    function MyTradeHistoryDetailRequest() {
    }
    return MyTradeHistoryDetailRequest;
}());
exports.MyTradeHistoryDetailRequest = MyTradeHistoryDetailRequest;
;
//# sourceMappingURL=myTradeHistoryDetail.request.js.map